<template lang="pug">
  #modalAccount.modal.fade(ref="modal", v-if="group")
    .modal-dialog(:class="{'modal-lg': showingHistory}")
      .modal-content
        .modal-header
          button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
          h4.modal-title {{$t("account.title")}} {{group.name}}
        .modal-body(v-if="paying")
          .text-center
            i.fa.fa-refresh.fa-spin.fa-4x
            h4 {{$t('account.gettingPayement')}}
        .modal-body(v-if="!paying")
          space-view(:divs="spaceViewDivs")
          hr
          .row
            .col-md-6.text-center {{$t("account.usedSpace")}} : {{ group.storageSize | hrS}}
            .col-md-6.text-center {{$t("account.freeSpace")}} : {{ freeSpace | hrS}}
          hr
          .row
            .col-md-12.text-center 
              | {{$t("account.maxSpace")}} : {{ group.storageMax | hrS}}
              br
              small(v-if="group.storageEnd") {{ $t("account.limitDate") }} {{group.storageEnd | unixtimeTo("L LT") }}
              small(v-else) {{ $t("account.noLimitDate") }}
              template(v-if="!showingBuyQuota")
                br
                br
                .btn.btn-default(@click="showBuyQuota", :class="{'btn-success': isDefaultQuota}") 
                  template(v-if="isDefaultQuota") {{$t('account.getMoreSpaceBtn')}}
                  template(v-else) {{$t('account.renewSpaceBtn')}}
          .buyQuota(v-if="showingBuyQuota")
            hr
            h4 {{$t("account.buyQuota.title")}}
            .table-responsive
              table.table.table-striped.table-bordered(v-if="!showingSpaceRange")
                tbody
                  tr
                    td {{ selectedSpaceRange.space * 1024 * 1024 | hrS }}
                    td {{$t('account.buyQuota.from')}} {{group.storageEnd | unixtimeTo("L") }} {{$t('account.buyQuota.to')}} {{ storageEndPlusOneYear | unixtimeTo("L") }} {{$t('account.buyQuota.oneYear')}}
                    td.text-right {{selectedSpaceRange.price}} &euro;
                  tr(v-if="balance.status == 'loaded' && balance.value > 0")
                    td(colspan=2)
                      | {{$t('account.buyQuota.previousBalance')}}
                      br
                      small {{$t('account.buyQuota.unused')}}
                    td.text-right -{{balance.value}} &euro;
                  tr
                    td(colspan=2) {{$t('account.buyQuota.toPay')}}
                    td.text-right {{ totalToPay }} &euro;
              table.table.table-striped.table-bordered(v-else)
                tbody
                  tr.clickable(v-for="range in spaceRanges",@click="selectSpaceRange(range)", :class="{warning: toMega( range.space) < group.storageSize}")
                    td.text-center
                      input(type="radio", name="spaceSelected", v-model="selectedSpaceRange",:value="range")
                    td
                      .nowrap {{ range.space * 1024 * 1024 | hrS }}
                    td
                      small(v-if="toMega( range.space) < group.storageSize") ({{$t('account.buyQuota.tooSmall')}})  
                      template(v-if="!range.from") {{$t('account.buyQuota.illimited')}}
                      template(v-else)
                        | {{$t('account.buyQuota.from')}} {{range.from / 1000 | unixtimeTo("L") }}
                        |  {{$t('account.buyQuota.to')}} {{range.to / 1000 | unixtimeTo("L") }}

                    td.text-right.nowrap {{range.price}} &euro;
                  tr(v-if="balance.status == 'loaded' && balance.value > 0")
                    td(colspan=3)
                      | {{$t('account.buyQuota.previousBalance')}}
                      br
                      small {{$t('account.buyQuota.unused')}}
                    td.text-right -{{balance.value}} &euro;
                  //- tr
                  //-   td(colspan=3) 
                  //-     | Réduction
                  //-     br
                  //-     small Remboursement de l'espace de 500 Mo d'aujourd'hui au 10/2/2017
                  //-   td.text-right -2.99 &euro;
                  tr
                    td(colspan=3) {{$t('account.buyQuota.toPay')}}
                    td.text-right {{ totalToPay }} &euro;
            .row
              .col-md-6
                a.clickable(@click="toggleSpaceRange") 
                  template(v-if="!showingSpaceRange") {{$t('account.buyQuota.changeSpaceToggler')}}
                  template(v-if="showingSpaceRange && !isDefaultQuota") {{$t('account.buyQuota.dontChangeSpaceToggler')}}
              .col-md-6.text-right
                .btn.btn-primary(@click="pay") 
                  template(v-if="totalToPay == '0.00'") {{$t('account.buyQuota.accept')}}
                  template(v-else) {{$t('account.buyQuota.pay')}}

          .history(v-if="showingHistory")
            hr
            h4 {{$t('account.history.title')}}
            template(v-if="invoices.status == 'loading'")
              i.fa.fa-refresh.fa-spin
              |  {{$t("globals.loading")}}
            template(v-if="invoices.status == 'error'")
              i.fa.fa-exclamation-triangle
              |  {{$t("globals.error")}}
            template(v-if="invoices.status == 'loaded'")
              .table-responsive
                table.table.table-striped.table-bordered
                  thead
                    tr
                      th {{$t('account.history.date')}}
                      th {{$t('account.history.explanation')}}
                      th {{$t('account.history.amount')}}
                      th {{$t('account.history.status')}}
                  tbody
                    tr(v-for="invoice in invoices.elems")
                      td 
                        | {{invoice.creationTime | unixtimeTo("L LT")}}
                        div(v-if="invoice.user") 
                          small {{$t('account.history.by')}} {{invoice.user.name}}
                      td {{$t("account.invoices.comment."+invoice.comment)}}
                        div(v-if="invoice.quota") 
                          small {{$t('account.history.quota')}} : {{invoice.quota * 1024 * 1024| hrS}}

                        div(v-if="invoice.untilDate") 
                          small {{$t('account.history.until')}} {{ invoice.untilDate | unixtimeTo("L LT")}}
                        div(v-if="invoice.closingDate && invoice.closingDate != invoice.untilDate") 
                          small {{$t('account.history.stopBefore')}} {{ invoice.closingDate | unixtimeTo("L LT")}}
                      td 
                        template(v-if="invoice.price != 0") {{invoice.currency}} {{Math.abs(invoice.price)}}
                        template(v-else) - 
                      td
                        template(v-if="invoice.status")
                          .badge(:class="{success: invoice.status == 'PAID', danger: invoice.status == 'CANCELLED'}") {{$t("account.invoices.status."+invoice.status)}}
                          div(v-if="invoice.paidDate") 
                            small {{ invoice.paidDate | unixtimeTo("L LT")}}
                      
        .modal-footer(v-if="!paying")
          .pull-left
            label.clickable
              input(type="checkbox", v-model="showingHistory")              
              | &nbsp; {{$t("account.history.toggle")}}
          .pull-right
            //- .btn.btn-default(@click="toggleHistory()") 
            //-   template(v-if="!showHistory") Voir l'historique
            //-   template(v-else) Cacher l'historique
            .btn.btn-primary(type="button", data-dismiss="modal", aria-hidden="true") {{ $t("globals.close") }}
</template>
<script>
import $ from 'jquery'
import _ from 'lodash'
import Vue from 'vue'
import {mapGetters} from 'vuex'
import moment from 'moment'
import SpaceView from './SpaceView'

import {hrS, unixtimeTo} from '@/components/shared/vue.globals'
import api from '@/utils/api'

import modalsBus from '@/components/shared/ModalsBus'
import Noty from '@/components/shared/Notify'

import VueStripeCheckout from 'vue-stripe-checkout'

const options = process.env.stripeOptions

Vue.use(VueStripeCheckout, options)

export default {
  data () {
    return {
      group: this.firstSelectedGroup,
      showingHistory: false,
      showingBuyQuota: false,
      toggleShowingSpaceRange: false,
      selectedSpaceRange: null,
      defaultQuota: 10,
      paying: false
    }
  },
  mounted () {
    modalsBus.onOpen((arg, object) => {
      if (arg === modalsBus.modals.OPEN_GROUP_ACCOUNT) {
        this.openOn(object)
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  components: {
    SpaceView
  },
  filters: {
    hrS,
    unixtimeTo
  },
  methods: {
    openOn (g) {
      this.setGroup(g)
      this.hideHistory()
      this.hideBuyQuota()
      this.paying = false
      if (!g.inQuotaOrder) {
        this.showBuyQuota()
      }
      this.hideSpaceRange()
      if (this.isDefaultQuota) {
        this.selectedSpaceRange = this.getBestSpaceRange()
      } else {
        this.selectedSpaceRange = this.getCurrentSpaceRangeOrBest()
      }
      return this.show()
    },
    show () {
      this.$nextTick(() => {
        $(this.$refs.modal).modal('show')
      })
    },
    closeModal () {
      return $(this.$refs.modal).modal('hide')
    },
    setGroup (g) {
      this.group = g
      this.$set(g, 'balance', void 0)
      this.$set(g, 'invoices', void 0)
      this.refreshGroupData()
    },
    refreshGroupData () {
      let g = this.group
      api.get('storageStats', {
        params: {
          group: g.id
        }
      }).then((response) => {
        let stats = response.data[g.id]
        this.$set(g, 'storageEnd', stats.storageEnd)
        this.$set(g, 'storageMax', stats.storageMax)
        this.$set(g, 'storageSize', stats.storageSize)
        this.$set(g, 'inQuotaOrder', stats.inQuotaOrder)
      })
      this.refreshBalance()
      this.refreshInvoices()
    },
    hideHistory () {
      this.showingHistory = false
    },
    toggleHistory () {
      this.showingHistory = !this.showingHistory
    },
    showBuyQuota () {
      this.showingBuyQuota = true
    },
    hideBuyQuota () {
      this.showingBuyQuota = false
    },
    toggleSpaceRange () {
      this.toggleShowingSpaceRange = !this.toggleShowingSpaceRange
    },
    hideSpaceRange () {
      this.toggleShowingSpaceRange = false
    },
    selectSpaceRange (range) {
      this.selectedSpaceRange = range
    },
    getCurrentSpaceRange () {
      var ranges
      ranges = this.spaceRanges.filter((r) => {
        return r.space * 1024 * 1024 === this.group.storageMax
      })
      if (ranges.length > 0) {
        return ranges[0]
      }
      return this.spaceRanges[1]
    },
    getCurrentSpaceRangeOrBest () {
      let range = this.getCurrentSpaceRange()
      let best = this.getBestSpaceRange()
      if (range.space < best.space) {
        return best
      }
      return range
    },
    getBestSpaceRange () {
      var max, ranges
      max = Math.max(Math.max(this.group.storageSize, this.group.storageMax), 100 * 1024 * 1024)
      ranges = this.spaceRanges.filter((r) => {
        return r.space * 1024 * 1024 >= max
      })
      if (ranges.length > 0) {
        return ranges[0]
      }
      return this.spaceRanges[1]
    },
    datesForQuota (quota) {
      if (quota === this.defaultQuota) {
        return null
      }
      if (this.toMega(quota) === this.group.storageMax) {
        return [moment.unix(this.group.storageEnd), moment.unix(this.group.storageEnd).add(1, 'year').subtract(1, 'day')]
      }
      return [moment(), moment().add(1, 'year').subtract(1, 'day')]
    },
    toMega (quota) {
      return quota * 1024 * 1024
    },
    refreshBalance () {
      this.$set(this.group, 'balance', null)
    },
    refreshInvoices () {
      this.$set(this.group, 'invoices', null)
    },
    pay () {
      let group = this.group
      if (parseFloat(this.totalToPay) === 0) {
        this.paying = true
        this.hideBuyQuota()
        api.post('pay',
          {
            group: group.id,
            amount: 0,
            space: this.selectedSpaceRange.space,
            price: this.selectedSpaceRange.price
          }).then(() => {
            this.paying = false
            this.refreshGroupData()
          })
      } else {
        this.$checkout.open({
          name: 'GroopUs.com',
          currency: 'EUR',
          amount: this.totalToPay * 100,
          token: (token) => {
            this.paying = true
            this.hideBuyQuota()
            api.post('pay',
              {
                group: group.id,
                amount: parseFloat(this.totalToPay),
                token: token.id,
                space: this.selectedSpaceRange.space,
                price: this.selectedSpaceRange.price
              }).then(() => {
                this.paying = false
                this.refreshGroupData()
              }).catch(() => {
                this.paying = false
                this.showBuyQuota()
                this.refreshGroupData()
                new Noty({
                  text: Vue.i18n.t('globals.error'),
                  type: 'error'
                }).show()
              })
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters('groops', [
      'selectedGroups',
      'firstSelectedGroup'
    ]),
    showingSpaceRange () {
      return this.isDefaultQuota || this.toggleShowingSpaceRange
    },
    isDefaultQuota () {
      return this.group.storageMax === this.defaultQuota * 1024 * 1024
    },
    freeSpace () {
      return Math.max(0, this.group.storageMax - this.group.storageSize)
    },
    quotaUsage () {
      return this.group.storageSize / this.group.storageMax
    },
    spaceViewDivs () {
      let sizeColor = '#36a2eb'
      if (this.quotaUsage >= 0.7 && this.quotaUsage < 0.9) {
        sizeColor = 'orange'
      } else if (this.quotaUsage >= 0.9) {
        sizeColor = 'red'
      }
      return [
        {
          name: Vue.i18n.t('account.usedSpaceLittle') + ' (' + hrS(this.group.storageSize) + ')',
          value: this.group.storageSize,
          color: sizeColor,
          fgcolor: 'white'
        }, {
          name: Vue.i18n.t('account.freeSpaceLittle') + ' (' + hrS(this.freeSpace) + ')',
          value: this.freeSpace,
          color: '#e7e9ed'
        }
      ]
    },
    spaceRanges () {
      var dates, range, ranges, _i, _len
      ranges = this.$store.getters['files/rangesCopy']
      for (_i = 0, _len = ranges.length; _i < _len; _i++) {
        range = ranges[_i]
        dates = this.datesForQuota(range.space)
        if (dates != null) {
          range.from = dates[0]
          range.to = dates[1]
        }
      }
      return ranges
    },
    balance () {
      if (this.group.balance != null) {
        return this.group.balance
      }
      var balance
      balance = {
        status: 'loading',
        value: 0
      }
      this.$set(this.group, 'balance', balance)
      api.get('/balance',
        {
          params: {
            group: this.group.id
          }
        }
      ).then((response) => {
        balance.value = response.data.balance
        balance.status = 'loaded'
      }).catch((data) => {
        balance.status = 'error'
      })
      return balance
    },
    invoices () {
      if (this.group.invoices != null) {
        return this.group.invoices
      }
      let invoices = {
        status: 'loading',
        elems: []
      }
      this.$set(this.group, 'invoices', invoices)
      api.get('/invoices',
        {
          params: {
            group: this.group.id
          }
        }
      ).then((response) => {
        this.$set(invoices, 'elems', response.data.invoices)
        invoices.status = 'loaded'
      }).catch((data) => {
        invoices.status = 'error'
      })
      return invoices
    },
    storageEndPlusOneYear () {
      return moment.unix(this.group.storageEnd).add(1, 'year').subtract(1, 'day').unix()
    },
    totalToPay () {
      var price
      price = this.selectedSpaceRange.price
      if (price === 0) {
        return '0.00'
      }
      let toPay = _.round(Math.max(this.selectedSpaceRange.price - this.balance.value, 0), 2).toFixed(2)
      if (toPay > 0 && toPay < 0.5) {
        toPay = 0.5
      }
      return toPay
    }
  },
  watch: {
    'group': {
      deep: true,
      handler () {
        this.selectedSpaceRange = this.getCurrentSpaceRangeOrBest()
      }
    },
    'toggleShowingSpaceRange' (newValue, oldValue) {
      if (this.toggleShowingSpaceRange) {
        this.selectedSpaceRange = this.getBestSpaceRange()
      } else {
        this.selectedSpaceRange = this.getCurrentSpaceRangeOrBest()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModalAccount.vue?355b2e05